import React from 'react';
import {Button, MandarkTable, ButtonGroup} from '@albert-io/atomic';

import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';

import InviteStudentsCards from '../EmptyStates/InviteStudentsCards.react';
import NoPendingInvitationsMessage from '../EmptyStates/NoPendingInvitationsMessage.react';
import InviteDropdownBtn from '../InviteDropdownBtn/InviteDropdownBtn.react';

import InvitedStudentsActionsDropdown from './InvitedStudentsActionsDropdown/InvitedStudentsActionsDropdown.react';

function getSearchFilters(query, term) {
  const encodedTerm = encodeURIComponent(term);
  return query.filter({
    email: {
      case_insensitive_substring: encodedTerm
    }
  });
}

export default class InvitedStudents extends React.Component {
  static contextType = ManageRosterContext;

  render() {
    const {invitations, students} = this.context;
    if (invitations.isEmpty() && students.isEmpty()) {
      return <InviteStudentsCards />;
    }

    if (invitations.isEmpty()) {
      return <NoPendingInvitationsMessage />;
    }

    return (
      <MandarkTable
        buttonGroup={
          <ButtonGroup>
            <Button onClick={() => this.context.setModalToShow('bulkResend')}>
              Re-send invitations
            </Button>
            <InviteDropdownBtn />
          </ButtonGroup>
        }
        theme='list'
        title='Invited'
        query={this.context.queries.invitations}
        searchFilters={getSearchFilters}
      >
        <MandarkTable.Column
          className='u-word-break_break-all'
          content={(invitation) => invitation.getEmail()}
          heading='Email'
          sortBy='email'
        />
        <MandarkTable.Column
          content={(invitation) =>
            // Use updated_at if sent_email_at is discovered to be null (the result of a race condition)
            invitation.getSentEmailAt()?.format('LL') || invitation.getUpdatedAt()?.format('LL')
          }
          defaultSortParam
          heading='Last invited'
          sortBy='sent_email_at'
        />
        <MandarkTable.Column
          align='right'
          isActionMenu
          content={(invitation) => <InvitedStudentsActionsDropdown invitation={invitation} />}
        />
      </MandarkTable>
    );
  }
}
